import React, { useState } from "react";
import AddClassCard from "./AddClassCard";
import SelectClassesModal from "./SelectClassesModal";
import SelectedClassesList from "../SelectedClassesListStep";
import { CardItem } from "../SelectedClassesListStep/ClassCard";
import styles from "./style.module.scss";
import axios from "axios";
import { composeApiURL } from "../../../../helpers/utility/axiosHelpers";

interface AddClassesProps {
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
  options: { label: string; value: string }[];
  loading?: boolean;
  error?: any;
  progressLimit: number;
  selectedCard: string | null;
  onDelete: (value: string) => void;
  onItemDelete: (value: string, mediaId: string) => void;
  classItemsMap?: Record<string, CardItem[]>;
  setClassItemsMap?: React.Dispatch<
    React.SetStateAction<Record<string, CardItem[]>>
  >;
  seedId: string | null;
  datasetId: string;
  showBlinkingCard?: boolean;
}

export interface SeedStepRef {
  handleOpenModal: () => void;
}

const SeedStep = React.forwardRef<SeedStepRef, AddClassesProps>(
  (
    {
      selectedValues,
      setSelectedValues,
      options,
      error,
      selectedCard,
      progressLimit,
      loading,
      onDelete,
      onItemDelete,
      classItemsMap,
      setClassItemsMap,
      seedId,
      datasetId,
      showBlinkingCard,
    },
    ref,
  ) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tempSelected, setTempSelected] = useState<string[]>([]);

    async function addClassToSeed(
      datasetId: string,
      seedId: string,
      labelCategoryIds: string[],
    ) {
      const url = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/flywheel/${datasetId}/seed/${seedId}/label_category_id`,
      );
      return axios.put(url, { label_category_ids: labelCategoryIds });
    }

    const handleOpenModal = () => {
      setTempSelected(selectedValues);
      setIsModalOpen(true);
    };

    const handleAdd = async () => {
      if (!datasetId || !seedId) return;
      await addClassToSeed(datasetId, seedId, tempSelected);

      setSelectedValues((prev) => {
        const merged = Array.from(new Set([...prev, ...tempSelected]));
        return merged;
      });

      setIsModalOpen(false);

      if (setClassItemsMap) {
        setClassItemsMap((prev) => {
          const newMap = { ...prev };
          tempSelected.forEach((val) => {
            if (!newMap[val]) {
              newMap[val] = [];
            }
          });
          return newMap;
        });
      }
    };

    const availableOptions = options.filter(
      (opt) => !classItemsMap || !classItemsMap[opt.value],
    );

    const availableSelectedValues = tempSelected.filter((val) =>
      availableOptions.some((opt) => opt.value === val),
    );

    // Expose handleOpenModal to parent via ref
    React.useImperativeHandle(ref, () => ({
      handleOpenModal,
    }));

    if (error) {
      return <div>Something went wrong.. </div>;
    }

    return (
      <div className={styles.seedStep}>
        <AddClassCard onClick={handleOpenModal} />

        <SelectClassesModal
          isModalOpen={isModalOpen}
          onCLose={() => setIsModalOpen(false)}
          options={availableOptions}
          selectedValues={availableSelectedValues}
          setSelectedValues={setTempSelected}
          loading={loading}
          onAdd={handleAdd}
        />

        <SelectedClassesList
          selectedItems={options.filter((opt) =>
            selectedValues.includes(opt.value),
          )}
          onDelete={onDelete}
          selectedCard={selectedCard}
          progressLimit={progressLimit}
          onItemDelete={onItemDelete}
          classItemsMap={classItemsMap}
          showBlinkingCard={showBlinkingCard}
        />
      </div>
    );
  },
);

export default SeedStep;
